<template>
  <div>
    <great></great>
    <title-transaction
      title="Últimas transações"
      style="margin-top: -12px"
    ></title-transaction>
    <resume-transactions></resume-transactions>
    <!--  <message-suport-client></message-suport-client>-->
    <modal-open-call-cellphone></modal-open-call-cellphone>
  </div>
</template>

<script>
import Great from "../../../welcome/Great";
import ResumeTransactions from "./ResumeTransactions";
import Title from "../../geral/Title";

import ModalOpenCallCellphone from "@/components/dashboard/enterprise/tools/ModalOpenCallCellphone";
export default {
  name: "ResumeEnterprise",
  components: {
    ModalOpenCallCellphone,
    "title-transaction": Title,
    ResumeTransactions,
    Great
  }
};
</script>

<style scoped></style>
